import Base from './base'
import renderFields from './gps.pug'

export default class Gps extends Base
  @label: "GPS 位置"

  renderFields: renderFields
